export const routes = {
  ACCESS_POINT: '/',
  ACCESS_POINT_ERROR: '/error/:errorType',
  CODELISTS: '/codelists',
  DASHBOARDS: '/dataflow/:dataflowId/dashboards',
  DATA_COLLECTION: '/dataflow/:dataflowId/dataCollection/:datasetId',
  DATAFLOW_FEEDBACK_CUSTODIAN: '/dataflow/:dataflowId/feedback',
  DATAFLOW_FEEDBACK: '/dataflow/:dataflowId/feedback/:representativeId',
  DATAFLOW_PROVIDER: '/dataflow/:dataflowId/provider/:providerId',
  DATAFLOW_REPRESENTATIVE: '/dataflow/:dataflowId/provider/:representativeId',
  DATAFLOW: '/dataflow/:dataflowId',
  DATAFLOWS_ERROR: '/dataflows/error/:errorType',
  DATAFLOWS_ID: '/dataflows/:dataflowId',
  DATAFLOWS: '/dataflows',
  DATASET_SCHEMA: '/dataflow/:dataflowId/datasetSchema/:datasetId',
  DATASET: '/dataflow/:dataflowId/dataset/:datasetId',
  DOCUMENTS: '/dataflow/:dataflowId/documents',
  EU_DATASET: '/dataflow/:dataflowId/euDataset/:datasetId',
  EULOGIN: '/eulogin',
  FME: 'https://fme.discomap.eea.europa.eu/fmeserver/#/job/:fmeJobId/summary',
  LEGAL_NOTICE: '/legalNotice',
  LOGIN: '/login',
  PRIVACY_POLICY_EIONET: 'https://www.eionet.europa.eu/reportnet/platform/footer/privacypolicy',
  PRIVACY_STATEMENT: '/privacyPolicy',
  PUBLIC_COUNTRIES: '/public/countries',
  PUBLIC_COUNTRY_INFORMATION_ID: '/public/countries/:countryCode',
  PUBLIC_COUNTRY_INFORMATION: '/public/country/:countryCode',
  PUBLIC_DATAFLOW_INFORMATION_ID: '/public/dataflows/:dataflowId',
  PUBLIC_DATAFLOW_INFORMATION: '/public/dataflow/:dataflowId',
  PUBLIC_DATAFLOWS: '/public/dataflows',
  REFERENCE_DATAFLOW: '/referenceDataflow/:referenceDataflowId',
  REFERENCE_DATASET_SCHEMA: '/referenceDataflow/:dataflowId/datasetSchema/:datasetId',
  REFERENCE_DATASET: '/referenceDataflow/:dataflowId/dataset/:datasetId',
  SETTINGS: '/settings',
  TEST_DATASETS: '/dataflow/:dataflowId/testDatasets'
};
